import React from 'react';
import EmailSignIn from './Steps/email';
import PasswordSignIn from './Steps/password';
import { useAuth } from '../../hooks/auth';
import RecoverPassword from './Steps/recoverPassword';
import FirstAccesSignIn from './Steps/firstAccess';
import LogosRow from '../BrandLogos';
import { StepsData } from '../../interfaces/StepsData';

const SignIn: React.FC = () => {
  const { step } = useAuth();
  const stepsVariations: StepsData = {
    fillEmail: <EmailSignIn />,
    fillPassword: <PasswordSignIn />,
    recoverPassword: <RecoverPassword />,
    firstAccess: <FirstAccesSignIn />,
  };
  return (
    <>
      <LogosRow />
      {stepsVariations[step]}
    </>
  );
};

export default SignIn;
